export interface CSVRecord {
  participantName: string;
  question: string;
  answerGiven: string;
  correctAnswer: string;
  pointsAwarded: number;
}

export function generateCSV(records: CSVRecord[]): string {
  const header = [
    'Participant Name',
    'Question',
    'Answer Given',
    'Correct Answer',
    'Points Awarded',
  ];
  const rows = records.map(r =>
    [
      r.participantName,
      r.question,
      r.answerGiven,
      r.correctAnswer,
      String(r.pointsAwarded),
    ]
      .map(field => '"' + String(field).replace(/"/g, '""') + '"')
      .join(',')
  );
  return [header.join(','), ...rows].join('\n');
}

export function downloadCSV(filename: string, csv: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

